import { STUDIO_COMP_REF_TYPE } from '../consts';
import { getEditorCapabilitiesForHost } from './editor-host-to-editor-type';
export const getCompRefType = (editorHost, breakpointId) => {
  const {
    usesClassicCompRefWithBreakpoint
  } = getEditorCapabilitiesForHost(editorHost);
  return (usesClassicCompRefWithBreakpoint ? breakpointId : STUDIO_COMP_REF_TYPE) ?? STUDIO_COMP_REF_TYPE;
};
//# sourceMappingURL=get-comp-ref-type.js.map